<template>
    <div class="detail" ref="detailBlindBox" @scroll="handleScroll">
        <div class="title re_relative re_flex_center re_font_18" :style="background" :class="{ 'is-pad-top': userStore.isPadTop }">
            <img src="../../../assets/blindBox/goBack.png" v-if="isWhite" @click="goBack()" alt="" />
            <van-icon @click="goBack()" class="icon" v-else  name="arrow-left" size="22" />
            <!-- <img src="../../../assets/goback1.png" v-else  @click="goBack()" alt=""> -->
            <span :style="{'opacity': isWhite ? 0 : 1}">泡泡详情</span>
        </div>
        <div class="swiper">
            <div class="swiper_img" v-if="detail.boxImageVideoType == 1">
                <van-swipe class="van_swiper" indicator-color="#FFFFFF" :autoplay="2000">
                    <van-swipe-item v-for="(item, index) in boxImgList" :key="index" class="image_item">
                        <img :src="item" alt="" @click="changeImg(index)">
                    </van-swipe-item>
                </van-swipe>
            </div>
            <div class="swiper_video" v-if="detail.boxImageVideoType == 2">
                <video :src="videoUrl" :poster="videoUrl + '?x-oss-process=video/snapshot,t_1000,f_jpg,m_fast,ar_auto'"></video>
                <div @click="playVideo(videoUrl)" class="mask" style="">
                    <van-icon name="play-circle-o" size="40" color="#ffffffbf"/>
                </div>
            </div>
            <div class="audio" @click="playAudio()">
                <div class="round">
                    <img src="../../../assets/blindBox/play.png" v-if="!showAudio" alt="">
                    <img src="../../../assets/blindBox/pause.png" v-if="showAudio" alt="">
                </div>
                <img src="../../../assets/blindBox/audio.png" alt="" v-if="showAudio">
                <img src="../../../assets/blindBox/audio.gif" alt="" v-if="!showAudio">
                <div>{{detail.boxAudioTime || '0'}}″</div>
                <audio type="audio/mp3" ref="audio" hidden="true" :src="voicePath" @ended="timeupdate">
                    您的浏览器不支持 audio 元素。
                </audio>
            </div>
        </div>
        <div class="reserve_seat"></div>
        <div class="padding">
            <detail-content :detail="detail" :active="active" :slign="'0'" :llhDetail="llhDetail" :userList="userList" @getDetail="getDetail" @toChat="toChat" @closeRedio="closeRedio"></detail-content>
        </div>
        <div style="height: 98px;width: 100%;"></div>
        <div class="footer" v-if="active == 0 && (detail.boxStatus == -1 || detail.boxStatus == 0 || detail.boxStatus == 3 || detail.boxStatus == 2)">
            <!-- 0-审核失败 1-审核中 2-展示中 3-已结束 -->
            <div class="btn" :style="{width: detail.boxStatus == 2 && detail.updateFlag == 0 ? '35%' : '100%'}" @click="withDrawShow = true" v-if="detail.boxStatus == 2">撤回</div>
            <div class="btn" v-if="detail.boxStatus == -1 || detail.boxStatus == 0 || detail.boxStatus == 3" @click="deleteShow = true">删除</div>
            <div class="btn edit" v-if="(detail.boxStatus == 2 && detail.updateFlag == 0)" style="width: 60%;" @click="toEdit">修改</div>
        </div>
        <div class="footer" v-if="active == 1">
            <div class="btn" v-if="token == ''" style="width: 35%;" @click="deleteShow = true">删除</div>
            <div class="btn edit" :style="{width: token != '' ? '100%' : '60%'}"  @click="toChat(detail, 'other')">给TA留言</div>
        </div>
        <div class="video" v-if="videoShow">
            
            <div class="music">
                <img class="musicOpen" v-if="!videoPause" @click="setVideo(true)" src="https://tp.kaishuihu.com/h5_red_static_img/openS.png" alt="">
                <img class="musicDown" v-if="videoPause" @click="setVideo(false)" src="https://tp.kaishuihu.com/h5_red_static_img/downS.png" alt="">
                <div></div>
            </div>
            <div @click="closeVideo" class="close">关闭视频</div>
            <video id="homeVideo" ref="video" muted="muted" class="video-js" playsinline="true" webkit-playsinline="true"
                 preload="auto" loop="loop" :poster="videoUrl + '?x-oss-process=video/snapshot,t_1000,f_jpg,m_fast,ar_auto'">
                <source :src="videoUrl" type="video/mp4" />
            </video>
        </div>
        <van-dialog  v-model:show="withDrawShow" title="提示" message="是否确认撤回此泡泡？" show-cancel-button @cancel="withDrawShow = false" @confirm="withdrawBox" />
        <van-dialog  v-model:show="deleteShow" title="提示" message="是否确认删除此泡泡？" show-cancel-button @cancel="deleteShow = false" @confirm="deleteBox" />
        <easter-egg v-if="openBox == '1'" :boxId="boxId" :boxType="'1'"></easter-egg>
    </div>
</template>
<script>
import { onMounted, ref, nextTick, onUnmounted } from 'vue';
import { useUserStore } from '../../stores/user';
import { router } from '../../router';
import { showToast, showImagePreview, showLoadingToast,closeToast  } from 'vant';
import { useRoute } from 'vue-router';
import { getMyOpenInfo, deleteBlindBox,getMySendOutInfo,remove, withdrawBlindBox,blindBoxDetailsInfo, getLlhTotal } from './api'
import easterEgg from './components/easterEgg.vue';
import detailContent from './components/content.vue';
export default {
    name: 'BlindBoxDetail',
    components:{
        easterEgg,detailContent
    },
    setup() {
        const userStore = useUserStore()
        const reout = useRoute()
        const openBox = ref(reout.query.openBox || '0') // 是否开泡泡
        // 我发出的  0  我收到的  1
        const active = ref(reout.query.active || 0)
        // 音频
        const audio = ref()
        // 泡泡详情
        const detail = ref({})    
        const boxImgList = ref([])
        
        const boxId = ref(reout.query.boxId || '')
        const boxRecordId = ref(reout.query.boxRecordId || '')
        // 返回上一步
        const goBack = () => {
            if (!reout.query.user_id) {
                return router.go(-1)
            }
            try {
                let u = navigator.userAgent;
                let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
                let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端

                if (isAndroid) {
                    appJsImp.finish()
                }
                if (isiOS) {
                    window.webkit.messageHandlers.AppModel.postMessage('finish')
                }
                nextTick(() => {
                    audio.value?.pause() // 暂停音频
                    if (audio.value.paused) { // 播放完成
                        showAudio.value = true
                    }
                })
            } catch (error) {
                router.back()
            }
        }
        // 是否展示音频
        const showAudio = ref(true)
        const voicePath = ref('')// 音频路径
        // 播放音频
        const playAudio = () => {
            nextTick(() => {
                // audio.value?.play()
                if(audio.value.paused) {
                    audio.value.play()
                    showAudio.value = audio.value.paused
                } else {
                    audio.value?.pause()
                    showAudio.value = audio.value.paused
                }
            })
            
        }
        // 监听音频播放
        const timeupdate = (e) => {
            // nextTick(() => {
                // if (audio.value.paused) { // 播放完成
                    showAudio.value = true
                // }
            // })
        }
        const changeImg = (index) => {
            console.log(index)
            showImagePreview({
                images: boxImgList.value,
                // closeable: true,
                loop: false,
                startPosition: index 
            });
        }
        // 是否展示视频
        const videoShow = ref(false)
        // 视频
        const video = ref()
        const videoUrl = ref('')
        // 播放视频
        const playVideo = (item) => {
            if (!showAudio.value) { 
                audio.value.pause()
                showAudio.value = audio.value.paused
            }
            videoShow.value = true;
            setTimeout(() => {
                video.value.play()
            }, 200);
        }
        // 视频静音
        const videoPause = ref(true)
        // 设置静音 
        const setVideo = (flag) => {
            video.value.muted = flag;
            videoPause.value = flag;
        }
        // 关闭视频
        const closeVideo = () => {
            videoShow.value = false;
            videoPause.value = true;
        }
        // 去聊天
        const toChat = (item, type) => {
            let u = navigator.userAgent;
            let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
            let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
            if (isAndroid) {
                if (type == 'other') {
                    appJsImp.toBlindBoxChat(item.accUserId, item.boxId, item.boxRecordId, 0)
                } else {
                    appJsImp.toBlindBoxChat(item.boxRecordAccUserId, item.boxId, item.boxRecordId, 0)
                }
            }
            if (isiOS) {
                if (type == 'other') {
                    window.webkit.messageHandlers.AppModel.postMessage({
                        name: 'toBlindBoxChat',
                        boxUserId: item.accUserId,
                        boxId: item.boxId,
                        boxRecordId: item.boxRecordId,
                        single: 0
                    })
                } else {
                    window.webkit.messageHandlers.AppModel.postMessage({
                        name: 'toBlindBoxChat',
                        boxUserId: item.boxRecordAccUserId,
                        boxId: item.boxId,
                        boxRecordId: item.boxRecordId,
                        single: 0
                    })
                }
                
            }
            nextTick(() => {
                audio.value?.pause(); // 暂停音频
                if (audio.value.paused) { // 播放完成
                    showAudio.value = true
                }
            })
        }
        // 去修改
        const toEdit = () => {
            let u = navigator.userAgent;
            let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
            let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
            if (isAndroid) {
                appJsImp.toEditBlindBox(boxId.value, 0)
            }
            if (isiOS) {
                window.webkit.messageHandlers.AppModel.postMessage({
                    name: 'toEditBlindBox',
                    boxId: boxId.value,
                    single: 0
                })
            }
            nextTick(() => {
                audio.value?.pause(); // 暂停音频
                showAudio.value = true
            })
        }
        // 撤回泡泡
        const withdrawBox = () => {
            withdrawBlindBox({boxId: boxId.value}).then(res => {
                if (res.code == 1) {
                    showToast('撤回成功')
                    getDetail()
                } else {
                    showToast(res.msg)
                }
            })
        }
        // 我发出的 删除泡泡
        const deleteBox = () => {
            let url = active.value == 0 ? remove : deleteBlindBox
            let param = {}
            if (active.value == 0) {
                url = remove
                param = {boxId: boxId.value}
            } else {
                url = deleteBlindBox
                param = {boxRecordId: boxRecordId.value}
            }
            url(param).then(res => {
                console.log(res, '删除泡泡')
                if (res.code == 1) {
                    showToast('删除成功')
                    setTimeout(() => {
                        goBack()
                    }, 1000)
                } else {
                    showToast(res.msg)
                }
            })
        }
        const getDetail = () => {
            let url = null
            let param = {boxId: boxId.value}
            if (active.value == 0) {
                url = getMySendOutInfo
            } else {
                url = getMyOpenInfo
            }
            // active.value == 0 ? getMySendOutInfo : getMyOpenInfo
            url(param).then(res => {
                if (res.code == 1) {
                    detail.value = res.data
                    voicePath.value = res.data.boxAudioUrl
                    boxImgList.value = detail.value.boxImageUrl.split(',')
                    videoUrl.value = boxImgList.value[0]
                    active.value == 1 ? getLlhTotalFn() : ''
                } else {
                    showToast(res.msg)
                }
            })
        }
        
        // 泡泡溜溜壶/苹果树
        const llhDetail = ref({})
        const getLlhTotalFn = () => {
            getLlhTotal({toUserId: detail.value.userId}).then(res => {
                if (res.code == 1) {
                    llhDetail.value = res.data
                }
            })
        }
        const page = ref(1)
        const size = ref(10)
        const pageFlag = ref(true)
        const userList = ref([])
        const listFlag = ref(false)
        const getUserList = ()=> {
            if (page.value == 1) {
                userList.value = []
            }
            listFlag.value = true
            blindBoxDetailsInfo({
                boxId: boxId.value,
                page: page.value,
                rows: size.value,
            }).then(res => {
                listFlag.value = false
                if (res.code == 1) {
                    if (page.value == 1) {
                        userList.value = res.data
                    } else {
                        userList.value = userList.value.concat(res.data)
                    }
                    page.value = page.value + 1
                    if (res.data.length < size.value) {
                        pageFlag.value = false
                    }
                } else {
                    showToast(res.msg)
                }
            })
        }
        const detailBlindBox = ref()
        const background = ref()
        const isWhite = ref(true)
        const handleScroll = () => {
            const container = detailBlindBox.value
            if (container.scrollTop + container.clientHeight >= container.scrollHeight - 44) {
                if(pageFlag.value) {
                    if (active.value == 0) {
                        if (listFlag.value == true) return
                        getUserList()
                    }
                }
            }
            if ((container.scrollTop / 105) > 0.7) {
                isWhite.value = false
                background.value = {
                    'background': 'rgba(255, 255, 255, ' + container.scrollTop / 105 + ')',
                    'color': 'rgba(0,0,0, ' + (container.scrollTop - 60) / 50 + ')'
                }
            } else {
                isWhite.value = true
                background.value = {
                    'background': 'rgba(255, 255, 255, ' + container.scrollTop / 105 + ')',
                    'color': 'rgba(255, 255, 255, ' + (1 - (container.scrollTop) / 50) + ')'
                }
            }
        }
        // 关闭音频
        const closeRedio = () => {
            nextTick(() => {
                audio.value?.pause() // 停止播放
                showAudio.value = true
            })
        }
        const token = ref(reout.query.token || '')
        onMounted(() => {
            getDetail()
            if (active.value == 0) {
                getUserList()
            }
            window.getInit = function () {
                page.value = 1
                getDetail()
                getUserList()
            };
        })
        onUnmounted(() => {
            userStore.setYounthActive(active.value)
            audio.value?.pause();
        })
        const withDrawShow = ref(false)
        const deleteShow = ref(false)
        return {
            withDrawShow,deleteShow,background,isWhite,openBox,boxId,llhDetail,
            userStore,audio,showAudio,videoShow,video,videoPause,active,videoUrl,detail,boxImgList,userList,detailBlindBox,voicePath,token,
            goBack,playAudio,timeupdate,playVideo,setVideo,closeVideo,toChat,toEdit,withdrawBox,deleteBox,handleScroll,changeImg, getDetail,closeRedio
        }
    }
}
</script>
<style lang="less" scoped>
@import url('./detail.less');
</style>